import {signOut} from 'aws-amplify/auth';

import {config} from '../config/amplify/auth';

// How long to wait for Amplify's own /logout navigation before leaving anyway.
const FALLBACK_DELAY_MS = 3000;

// FNP-1685: sign out through the auth broker's /logout to this stage's
// redirectSignOut (the portal). Naming the URL explicitly is what stops Amplify
// throwing InvalidOriginException for a cross-origin logout target.
//
// On an OAuth session Amplify sets window.location to /logout and resolves at
// once, so do NOT navigate straight away: that would replace the redirect.
// With no OAuth session signOut resolves WITHOUT navigating, so a delayed
// fallback leaves for '/'; if Amplify did navigate, the page unloads first and
// the timer never fires. A rejection (tokens are cleared first either way)
// leaves for '/' at once.
export const signOutViaBroker = async () => {
    const redirectUrl = config?.Cognito.loginWith?.oauth?.redirectSignOut[0];
    try {
        // global: false is signOut()'s own default; the typed input requires it.
        await signOut({global: false, oauth: {redirectUrl}});
        setTimeout(() => {
            window.location.href = '/';
        }, FALLBACK_DELAY_MS);
    } catch (error) {
        console.error('Sign out did not complete cleanly', error);
        window.location.href = '/';
    }
};
